import { create } from "zustand";
import type { Change } from "./git";

/**
 * Alterações, o que está preparado para o commit e a mensagem: comuns ao painel Git, ao rodapé
 * "Git" do explorador e às marcas na árvore. Sem nada preparado, o commit leva tudo (como o
 * "smart commit" do VS Code).
 */
export const useGitChanges = create<{
  key: string | null;
  changes: Change[] | null;
  scanning: boolean;
  message: string;
  staged: string[];
  /** Arquivos que mudaram dos dois lados no último pull (ficaram com a versão do Kompil). */
  conflicts: string[];
}>(() => ({ key: null, changes: null, scanning: false, message: "", staged: [], conflicts: [] }));

export const stagedSet = () => new Set(useGitChanges.getState().staged);
export function stage(paths: string[]) {
  useGitChanges.setState((s) => ({ staged: [...new Set([...s.staged, ...paths])] }));
}
export function unstage(paths: string[]) {
  const drop = new Set(paths);
  useGitChanges.setState((s) => ({ staged: s.staged.filter((p) => !drop.has(p)) }));
}
